/* eslint-disable dot-notation */
export const TOKEN_STORE_KEY = 'login.token';
export const JWT_COOKIE_NAME = window['env'].REACT_APP_JWT_COOKIE_NAME || '';
export const JWT_COOKIE_DOMAIN = window['env'].REACT_APP_JWT_COOKIE_DOMAIN || '';
export const LOGOUT_REDIRECT = window['env'].REACT_APP_LOGOUT_REDIRECT || '';
export const BASE_SERVICE = window['env'].REACT_APP_BASE_SERVICE || '';
export const METADATA_SERVICE = window['env'].REACT_APP_METADATA_SERVICE || '';
export const AUTH_SERVICE = window['env'].REACT_APP_AUTH_SERVICE || '';
export const BASENAME = window['env'].REACT_APP_BASENAME_ROUTER || '';
export const STATUS_URL = window['env'].REACT_APP_STATUS_URL || '';
export const STATUS_SERVICE = window['env'].REACT_APP_STATUS_SERVICE || '';
export const BI_URL = window['env'].REACT_APP_BI_URL || '';
export const PROJECT_URL = window['env'].REACT_APP_PROJECT_URL || '';
export const INTEGRATION_URL = window['env'].REACT_APP_INTEGRATION_URL || '';
export const DASHBOARD_URL = window['env'].REACT_APP_DASHBOARD_URL || '';
export const INTEGRATION_DASHBOARD_URL = window['env'].REACT_APP_INTEGRATION_DASHBOARD_URL || '';
